<template>
    <div class="columns is-multiline is-desktop">
        <div :class="columnClass" v-for="laptop in laptops" :key="laptop.id">
            <ProductCard :laptop="laptop" :key="laptop.id" :awaiting="awaiting"/>
        </div>
    </div>
</template>
<script>
    import ProductCard from './ProductCard'

    export default {
        name: "ProductsGrid",
        components: {ProductCard},
        props: {
            laptops: Array,
            columnWidth: Number,
            awaiting: Boolean
        },
        data() {
            return {
                focusedId: undefined,
                columnClass: ['column', 'is-' + this.columnWidth],
                // awaiting: this.awaiting
                // dollar_rate:Number,
            }
        },
        // methods: {
        //     fetchDollarRate() {
        //         axios.get(API_URL + '/dollar')
        //             .then(response => {
        //                 this.dollar_rate = response.data[0].exchange_rate
        //             })
        //     },
        // },
        // mounted() {
        //     this.fetchDollarRate()
        // }
    }
</script>
